/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb2niw_Point_0_TextInputs */

const en_visa_eb2niw_point_0_text = /** @type {(inputs: Visa_Eb2niw_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We review education, experience, expertise, and the real-world value of the proposed work to determine whether NIW is a realistic fit.`)
};

const pt_visa_eb2niw_point_0_text = /** @type {(inputs: Visa_Eb2niw_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisamos educação, experiência, especialização e o valor real do trabalho proposto para determinar se o NIW é uma opção realista.`)
};

const es_visa_eb2niw_point_0_text = /** @type {(inputs: Visa_Eb2niw_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisamos educación, experiencia, especialización y el valor real del trabajo propuesto para determinar si el NIW es una opción realista.`)
};

/**
* | output |
* | --- |
* | "We review education, experience, expertise, and the real-world value of the proposed work to determine whether NIW is a realistic fit." |
*
* @param {Visa_Eb2niw_Point_0_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb2niw_point_0_text = /** @type {((inputs?: Visa_Eb2niw_Point_0_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb2niw_Point_0_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb2niw_point_0_text(inputs)
	if (locale === "es") return es_visa_eb2niw_point_0_text(inputs)
	return en_visa_eb2niw_point_0_text(inputs)
});